<template>
	<div class="card">
		<div class="card-main flex" @click="$emit('click', data)">
			<div class="flex-grow">
				<div class="card-info flex-start">
					<div v-if="$slots.tag" class="tag flex">
						<slot name="tag"></slot>
					</div>
					<p v-if="$slots.name" class="title flex-grow">
						<slot name="name"></slot>
					</p>
					<p v-if="$slots.number" class="number flex-grow flex-start-center ellipsis">
						<i class="tf">&#xe6db;</i>
						<slot name="number"></slot>
					</p>
					<p v-if="$slots.date" class="date flex-grow ellipsis">
						<slot name="date"></slot>
					</p>
					<div v-if="$slots.state" class="state">
						<slot name="state"></slot>
					</div>
				</div>

				<div v-if="$slots.default" class="card-field">
					<slot></slot>
				</div>

				<div v-if="$slots.area" class="card-area">
					<div v-if="$slots.areaName" class="card-area-info flex-start">
						<div v-if="$slots.areaTag" class="tag flex">
							<slot name="areaTag"></slot>
						</div>
						<p class="title flex-grow">
							<slot name="areaName"></slot>
						</p>
					</div>
					<slot name="area"></slot>
				</div>
			</div>
			<slot name="total"></slot>
		</div>
		<div v-if="$slots.operate" class="card-button flex-end-center flex-wrap">
			<slot name="operate"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'viewListCard',

		props: {
			data: Object
		},

		data() {
			return {
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.card {
		position: relative;
		border-radius: .16rem;
		padding: .24rem;
		margin: 0 .24rem;
		background: #fff;

		&-main {
			gap: .2rem;
		}

		&-info {
			gap: .16rem;
			margin-bottom: .2rem;

			.tag {
				gap: .1rem;
			}

			.title {
				line-height: .36rem;
				font-size: .28rem;
			}

			.number {
				gap: .12rem;
				height: .36rem;
				font-size: .26rem;
				color: var(--color-main);
			}

			.date {
				line-height: .36rem;
				font-size: .26rem;
				color: var(--color-main);
			}
		}

		&-field {
			>>> .c-field {
				&:nth-child(n+2) {
					margin-top: .06rem;
				}
			}
		}

		&-area {
			border-radius: .08rem;
			padding: .12rem .2rem;
			background: #F9F9F9;

			&-info {
				gap: .16rem;
				margin: .08rem 0 .2rem;

				.tag {
					gap: .1rem;
				}

				.title {
					line-height: .36rem;
					font-size: .28rem;
				}
			}

			>>> .c-field {
				&:nth-child(n+2) {
					margin-top: .06rem;
				}
			}

			>>> .c-field-label,
			>>> .c-field-content label {
				color: #666;
			}
		}

		&-button {
			gap: .12rem;
			margin-top: .2rem;
		}
	}
</style>
